var AnimationType;
(function (AnimationType) {
  AnimationType["Animate"] = "animate";
  AnimationType["Hover"] = "whileHover";
  AnimationType["Tap"] = "whileTap";
  AnimationType["Drag"] = "whileDrag";
  AnimationType["Focus"] = "whileFocus";
  AnimationType["InView"] = "whileInView";
  AnimationType["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));
export { AnimationType };